<script>
import { about_panel_state } from "./util/stores.js"


</script>

<button class="dim_bg" on:click={() => {about_panel_state.set(false)}}>
</button>

<div>
    <div class="card">
        <h1 class="title">About Avenoir</h1>
        <h2 class="definition"><i>/avənwär/</i> - n. The desire to see memories in advance.</h2>
        <h2 class="info">
            Avenoir is a modern interactive <b>web app tool for outlining</b> a written work through a modular set of components, that reflect various aspects of the work. 
            <br><br>
            This can be used to conceptually outline a work that is to be written and thus construct an <b>understanding before writing</b> it. You may also <b>share</b> your outline with others simply via URL link, so that anyone can get a better idea of your written work.
            <br><br>
            Created in Latvia, 2021 by Rolands Laucis - rolandslaucis.lv</h2>
        <img alt="pic" src="../pics/icons/avenoir_logo.svg">
    </div>
</div>

<style lang="scss">

    .dim_bg{
        width: 100%;
        height: calc(100% - #{$col_strip_h} - #{$nav_bar_h});
        margin: auto;

        border: none;
        cursor: pointer;

        position: absolute;
        z-index: 8;
        
        background:rgba(0,0,0,0.6);
    }

    .card{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 9;
        width: 965px;
        height: 543px;
        cursor:default;

        background: #FFFFFF;
        box-shadow: 0px 0px 83px 11px rgba(0, 0, 0, 0.05);
        border-radius: 29px 69px 69px 69px;

        display: grid;
        grid-template-columns: 44px 1fr 1fr;
        grid-template-rows: 16.2% 9.76% 55.61% auto;
        grid-template-areas: 
            ". title ."
            ". definition pic"
            ". info pic"
            ". . .";

        .title{
            grid-area: title;
            justify-self: start;
			align-self: center;

            font-style: normal;
            font-weight: bold;
            font-size: 27px;
            line-height: 30px;
        }

        .definition{
            grid-area: definition;
            justify-self: start;
			align-self: center;

            font-style: normal;
            font-weight: 300;
            font-size: 22px;
            line-height: 162.9%;
        }

        .info{
            grid-area: info;
            justify-self: start;
			align-self: flex-end;

            font-style: normal;
            font-weight: normal;
            font-size: 17px;
            line-height: 19px;
        }

        img{
            grid-area: pic;
            justify-self: center;
			align-self: center;

            width: 391px;
            height: 355px;

            //border: solid 1px black;
            //border-radius: 8px;
        }
    }
</style>